import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";
import MediaWrapper from "@/components/mediaWrapper";

/*
  This component requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/

export const query = graphql`
  fragment ContentCenteredData on StrapiComponentContentCentered {
    title
    topic
    description
    image {
      ...StrapiMediaSubquery
    }
    body {
      ...StrapiSharedBody
    }
    useToc
    tocTitle
    tocIncludedHeadings {
      string
    }
  }
`;

function Centered({ data }) {
  if (!data) {
    return <></>;
  }

  return (
    <div className="overflow-hidden bg-background-transparent">
      <div className="mx-auto w-full bg-background-white px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-prose text-lg">
          {data.topic && (
            <h2 className="block text-center text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h2>
          )}
          {data.title && (
            <h1 className="mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-text-primary sm:text-4xl">
              <MarkdownWrapper text={data.title} />
            </h1>
          )}
          {data.image && (
            <MediaWrapper
              media={data.image}
              divClassName={"w-full my-10 rounded-lg"}
            />
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-8 text-xl text-text-secondary leading-8 prose"
              replaceParagraph={false}
            />
          )}
        </div>
        {data.body && data.body.text && (
          <div className="prose-prose-primary prose prose-lg mx-auto mt-6 text-text-secondary">
            <MarkdownWrapper
              text={data.body.text}
              useToc={data.useToc || false}
              tocTitle={data.tocTitle || "Table of Content"}
              tocOptions={{
                headings: data.tocIncludedHeadings?.lenght
                  ? data.tocIncludedHeadings?.map((e) => e.string)
                  : ["h1", "h2"],
                cssClasses: {
                  // cant escape from prose. so cant style toc.
                  toc: "not-prose",
                  list: "not-prose list-none",
                  listItem: "not-prose list-none",
                  link: "not-prose",
                },
              }}
              replaceParagraph={false}
              images={data.body.images}
              imgDivClassName="w-full"
              imgClassName="rounded-lg"
              useImgCaption
            />
          </div>
        )}
      </div>
    </div>
  );
}

Centered.propTypes = {
  data: PropTypes.object,
};

export default Centered;
